// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-banner {
    position: relative;
    width: 100%;
    max-height: 80vh;
    height: 80vh;
    border-radius: var(--border-radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-banner-container{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radius-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 2300px;

  }
  .main-banner-video{
    position: relative;
    width: 100%;
    max-height: 80vh;
    height: 80vh;
    border-radius: var(--border-radius-lg);
    display: flex;
    align-items: start;
    justify-content: center;
    margin-top: 32px;

  }
  .main-banner-video .main-banner-container{
    display: flex;
    align-items: start;
    justify-content: center;
    height: 100%;
    width: 100%;

  }
  /* Стили для видео на фоне */
  .background-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
  .background-video-label{
    position: relative;
    z-index: 3;
  }
  
  /* Слой затемнения для лучшей читаемости текста */
  .main-banner-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный цвет */
    z-index: 2;
  }
  
  /* Контейнер для контента */
  .content-container {
    position: relative;
    width: 100%;
    max-width: 1100px;
    z-index: 3;
    padding: 0 20px;
    box-sizing: border-box;
  }
  
  /* Стили для текстового блока */
  .text-content {
    display: flex;
    flex-direction: column;
    align-items: start;
    /* text-align: center; */
    gap: 32px;
    color: white;
  }
  
  /* Стили для компонента banner-label */
  .banner-label {
    margin-bottom: 8px;
  }
  
  
  h1 {
    font-size: var(--font-size-4xl);
    font-weight: var(--font-bold);
    text-align: left;
  }
  .subtitle-container{
    width: 635px;
  }
  h4 {
    font-size: var(--font-size-lg);
    font-weight: var(--font-bold);
    margin-top: 0;
    text-align: left;
    white-space: pre-wrap;
  }
  /* Стили для параграфа */
  .text-content p {
    text-align: left;
    font-size: var(--font-size-md);
    max-width: 800px;
    line-height: 1.6;
    margin: 0;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
    white-space: pre-wrap;
  }
  /* Адаптивность для мобильных устройств */
  @media (max-width: 768px) {
    .text-content p {
      font-size: 1rem;
    }
  }
  @media (max-width: 999px) {
    
    .main-banner-video{
      height: 60vh;
    }
    .main-banner{
      height: auto;
    }
    .main-banner .main-banner-container{
      padding: 100px 0;
      padding-top: 160px;
    }
    .main-banner-video .main-banner-container{
      padding: 0 20px;
    }
  }
  /* Адаптивность для мобильных устройств */
  @media (max-width: 768px) {
    .text-content p {
      font-size: var(--font-size-md);
      width: 100%;
      text-align: center;
    }
    .text-content h1{
      font-size: var(--font-size-2xl);
      width: 100%;
      text-align: center;
    }
    .text-content{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .subtitle-container{
      width: 100%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Home/sections/Banner/Banner.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;;EAEnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;;EAElB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,WAAW;;EAEb;EACA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,+BAA+B;IAC/D,UAAU;EACZ;;EAEA,2BAA2B;EAC3B;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,YAAY;EACd;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;EACpB;;;EAGA;IACE,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,qBAAqB;EACvB;EACA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,2CAA2C;IAC3C,qBAAqB;EACvB;EACA,yCAAyC;EACzC;IACE;MACE,eAAe;IACjB;EACF;EACA;;IAEE;MACE,YAAY;IACd;IACA;MACE,YAAY;IACd;IACA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;EACF;EACA,yCAAyC;EACzC;IACE;MACE,8BAA8B;MAC9B,WAAW;MACX,kBAAkB;IACpB;IACA;MACE,+BAA+B;MAC/B,WAAW;MACX,kBAAkB;IACpB;IACA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;IACrB;IACA;MACE,WAAW;IACb;EACF","sourcesContent":[".main-banner {\n    position: relative;\n    width: 100%;\n    max-height: 80vh;\n    height: 80vh;\n    border-radius: var(--border-radius-lg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .main-banner-container{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    border-radius: var(--border-radius-lg);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 2300px;\n\n  }\n  .main-banner-video{\n    position: relative;\n    width: 100%;\n    max-height: 80vh;\n    height: 80vh;\n    border-radius: var(--border-radius-lg);\n    display: flex;\n    align-items: start;\n    justify-content: center;\n    margin-top: 32px;\n\n  }\n  .main-banner-video .main-banner-container{\n    display: flex;\n    align-items: start;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n\n  }\n  /* Стили для видео на фоне */\n  .background-video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 1;\n  }\n  .background-video-label{\n    position: relative;\n    z-index: 3;\n  }\n  \n  /* Слой затемнения для лучшей читаемости текста */\n  .main-banner-container::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* Полупрозрачный черный цвет */\n    z-index: 2;\n  }\n  \n  /* Контейнер для контента */\n  .content-container {\n    position: relative;\n    width: 100%;\n    max-width: 1100px;\n    z-index: 3;\n    padding: 0 20px;\n    box-sizing: border-box;\n  }\n  \n  /* Стили для текстового блока */\n  .text-content {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    /* text-align: center; */\n    gap: 32px;\n    color: white;\n  }\n  \n  /* Стили для компонента banner-label */\n  .banner-label {\n    margin-bottom: 8px;\n  }\n  \n  \n  h1 {\n    font-size: var(--font-size-4xl);\n    font-weight: var(--font-bold);\n    text-align: left;\n  }\n  .subtitle-container{\n    width: 635px;\n  }\n  h4 {\n    font-size: var(--font-size-lg);\n    font-weight: var(--font-bold);\n    margin-top: 0;\n    text-align: left;\n    white-space: pre-wrap;\n  }\n  /* Стили для параграфа */\n  .text-content p {\n    text-align: left;\n    font-size: var(--font-size-md);\n    max-width: 800px;\n    line-height: 1.6;\n    margin: 0;\n    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n    white-space: pre-wrap;\n  }\n  /* Адаптивность для мобильных устройств */\n  @media (max-width: 768px) {\n    .text-content p {\n      font-size: 1rem;\n    }\n  }\n  @media (max-width: 999px) {\n    \n    .main-banner-video{\n      height: 60vh;\n    }\n    .main-banner{\n      height: auto;\n    }\n    .main-banner .main-banner-container{\n      padding: 100px 0;\n      padding-top: 160px;\n    }\n    .main-banner-video .main-banner-container{\n      padding: 0 20px;\n    }\n  }\n  /* Адаптивность для мобильных устройств */\n  @media (max-width: 768px) {\n    .text-content p {\n      font-size: var(--font-size-md);\n      width: 100%;\n      text-align: center;\n    }\n    .text-content h1{\n      font-size: var(--font-size-2xl);\n      width: 100%;\n      text-align: center;\n    }\n    .text-content{\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n    .subtitle-container{\n      width: 100%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
